/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.cardetail,
            url: '/' + 'cardetail',
            params: {
                _ga: '',
                gac: ''
            },
            cache: false,
            title: 'Voertuig gegevens',
            headerTitle: 'Plan uw afspraak',
            configuratorStepName: ['LicensePlateStep'],
            order: Constants.defaultStepNumber,
            operations: ['SetLicensePlate', 'SetStore'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/cardetail.html',
                    controller: Controllers.CarDetailController.controllerId + ' as vm'
                },
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }
    
    App.Core.appCore.run(appRun);
}